export const formatOrderDate = (date: Date | string | undefined): string => {
  if (!date) return '-'
  const d = new Date(date)
  return `${d.toLocaleDateString('pt-BR')} às ${d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}h`
}
